<div class="form-group">
  <label [for]="inputId" *ngIf="!suppressLabel">{{ translateTag | translate: translateParams }}</label>
  <div
    ngbDropdown
    #myDrop="ngbDropdown"
    [autoClose]="'outside'"
    placement="bottom-left"
    (openChange)="openChanged($event)"
    [id]="inputId"
    class="p-0"
    [class.form-control]="!renderStatic"
  >
    <button
      type="button"
      [disabled]="renderStatic || disabled"
      class="w-100 border-0 text-left dropdown"
      [ngClass]="{ 'btn btn-block': !renderStatic }"
      ngbDropdownToggle
    >
      <div class="d-flex align-items-center">
        <span class="w-100 text-truncate">{{ value }}&nbsp;</span>
        <i
          *ngIf="value && !disabled && !renderStatic"
          class="fal fa-times mx-2"
          role="button"
          (click)="$event.stopPropagation(); $event.preventDefault(); value = ''; onTouched()"
        ></i>
        <i
          *ngIf="!renderStatic"
          class="fa float-right ml-auto"
          [ngClass]="{ 'fa-chevron-down': !dropdownIsOpen, 'fa-chevron-up': dropdownIsOpen }"
        ></i>
      </div>
    </button>
    <ul class="dropdown-list" ngbDropdownMenu>
      <li (keydown.enter)="$event.preventDefault()">
        <lib-filter-list-search (searchUpdated)="setSearch($event)"></lib-filter-list-search>
      </li>
      <li *ngIf="filteredList.length === 0" class="px-3 pb-2">
        {{ 'NO_RESULTS_FOUND' | translate }}
      </li>
      <li *ngFor="let item of filteredList" class="item">
        <button type="button" class="btn w-100 text-left" (click)="selected(item); myDrop.close()">
          {{ item }}
        </button>
      </li>
      <li class="add-new border-top">
        <button *ngIf="!isAdding" type="button" class="btn w-100 text-left" (click)="startAdding()">
          <i class="fal fa-plus mr-2"></i>{{ 'ADD_NEW_ASSORTMENT' | translate }}
        </button>
        <div *ngIf="isAdding" class="input-group flex-nowrap p-2">
          <input
            #newAssortmentInput
            type="text"
            class="form-control"
            [placeholder]="'ASSORTMENT' | translate"
            [(ngModel)]="newAssortment"
            [ngModelOptions]="{ standalone: true }"
            (keydown.enter)="$event.preventDefault(); addNew() && myDrop.close()"
          />
          <button
            type="button"
            class="btn btn-primary text-nowrap"
            [disabled]="!newAssortment?.trim()"
            (click)="addNew(); myDrop.close()"
          >
            {{ 'ADD' | translate }}
          </button>
        </div>
      </li>
    </ul>
  </div>
</div>
